<script lang="ts">
    import { Col,  Label, Row } from "sveltestrap";
    import { Radios } from "../../../../utils/Constant/Constant";
    import data from "../../../../Data/Forms/FormLayout/FormLayout.json"
</script>
<fieldset class="mb-3">
    <Row>
        <Col sm="3">
            <Label class="col-form-label pt-0">{Radios}</Label>
        </Col>
        <Col sm="9">
            {#each data.radiodata as formItem}
                <div class="form-check radio radio-primary">
                    <input class="form-check-input" id={formItem.id} type="radio" name="radio1" value="option1" disabled={formItem.id === "radio33" ? true : false}>
                    <label class="form-check-label" for={formItem.id}>{formItem.name}</label>
                </div>
            {/each}
        </Col>
    </Row>
</fieldset>